import { useEffect, useState } from 'react';
import {StaffConnection} from '../../components/connection/StaffConnection';
import { NavLink, useLocation } from 'react-router-dom';
import { Building2, LayoutDashboard, Users, UserRoundPlus, FolderOpen, ArrowDownToLine, ArrowUpFromLine, ArrowLeftRight, Bell, Settings2, UserRound, Tags, GitBranch, UserCog, LogOut, Menu, X, ShieldCheck, ChevronDown, PanelsTopLeft } from 'lucide-react';
import { toast } from 'sonner';
import { apiError, useCRMAuth } from '../context/CRMAuthContext';
import {crmRoleLabel} from '../roleLabels';
import {TenantBrand} from '../../branding/BrandingContext';
import {WebteraLogo} from '../../components/WebteraLogo';

const icons = { dashboard: LayoutDashboard, pending: UserRoundPlus, leads: UserRoundPlus, 'data-lists': FolderOpen, assignment: UserCog, customers: Users, deposits: ArrowDownToLine, withdrawals: ArrowUpFromLine, transfers: ArrowLeftRight, banks: Building2, notifications: Bell, profile: UserRound, references: GitBranch, tags: Tags, users: Settings2 };

export const CRMLayout = ({ children }) => {
  const { user, tenant_name, navigation, logout } = useCRMAuth();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [menu, setMenu] = useState(false);
  useEffect(() => { setOpen(false); setMenu(false); }, [location.pathname]);
  useEffect(() => {
    const desktop = window.matchMedia('(min-width: 901px)');
    const closeDrawer = () => { if (desktop.matches) setOpen(false); };
    desktop.addEventListener('change', closeDrawer);
    closeDrawer();
    return () => desktop.removeEventListener('change', closeDrawer);
  }, []);
  useEffect(() => {
    const key = e => { if (e.key === 'Escape') { setOpen(false); setMenu(false); } };
    window.addEventListener('keydown', key);
    return () => window.removeEventListener('keydown', key);
  }, []);
  const groups = [...new Set(navigation.map(item => item.group))];
  const current = navigation.find(item => item.path === location.pathname);
  return <div className="crm-workspace" data-testid="crm-workspace">
    {open && <button className="crm-drawer-overlay" aria-label="Menüyü kapat" data-testid="crm-drawer-overlay" onClick={() => setOpen(false)} />}
    <aside className={`crm-sidebar ${open ? 'is-open' : ''}`} data-testid="crm-sidebar">
      <div className="crm-brand"><NavLink to="/crm" className="crm-wordmark" data-testid="crm-brand-link"><TenantBrand id="crm-workspace-brand" fallback={<WebteraLogo size={24} subtitle="CRM" />}/></NavLink><button className="crm-mobile-only crm-icon-button" onClick={() => setOpen(false)} aria-label="Menüyü kapat" data-testid="crm-close-navigation"><X size={20} /></button></div>
      <div className="crm-tenant"><Building2 size={17} /><span data-testid="crm-tenant-name">{tenant_name}</span><ShieldCheck size={14} /></div>
      <nav aria-label="Ana menü" className="crm-navigation">
        {groups.map((group, index) => <div className="crm-nav-group" key={group || 'main'}>
          {group && <p className="crm-nav-label">{group}</p>}
          {navigation.filter(item => item.group === group).map(item => {
            const Icon = icons[item.id] || FolderOpen;
            return <NavLink key={item.id} to={item.path} end data-testid={`crm-nav-${item.id}`} className={({ isActive }) => `crm-nav-item ${isActive ? 'is-active' : ''}`}><Icon size={17} /><span>{item.label}</span></NavLink>;
          })}
        </div>)}
      </nav>
      <NavLink to="/admin" className="crm-workspace-switch" data-testid="crm-workspace-switch"><PanelsTopLeft size={17} />Çalışma Alanları<ArrowLeftRight size={15} /></NavLink>
      <div className="crm-sidebar-footer"><span className="crm-status-dot" />Personel çalışma alanı<span>01</span></div>
    </aside>
    <div className="crm-main">
      <header className="crm-header">
        <button className="crm-mobile-only crm-icon-button" data-testid="crm-open-navigation" onClick={() => setOpen(true)} aria-label="Menüyü aç"><Menu size={21} /></button>
        <div className="crm-breadcrumb">Çalışma alanı<span>/</span><strong>{current?.label || 'Müşteri kaydı'}</strong></div>
        <div className="crm-user-menu">
          <button className="crm-user-toggle" data-testid="crm-user-menu-toggle" onClick={() => setMenu(!menu)} aria-expanded={menu}><span className="crm-avatar">{user.first_name[0]}{user.last_name[0]}</span><span className="crm-user-text"><strong data-testid="crm-current-user">{user.first_name} {user.last_name}</strong><small data-testid="crm-current-role">{crmRoleLabel(user)}</small></span><ChevronDown size={15} /></button>
          {menu && <div className="crm-user-popover" data-testid="crm-user-menu"><NavLink data-testid="crm-user-profile-link" to="/crm/profile"><UserRound size={16} />Profilim</NavLink><button data-testid="crm-logout" onClick={() => logout().catch(e => toast.error(apiError(e)))}><LogOut size={16} />Çıkış Yap</button></div>}
        </div>
      </header>
      <StaffConnection/>
      <main className="crm-content">{children}</main>
      <footer className="crm-content-footer">BROKER CRM<span>Kurumsal çalışma alanı</span></footer>
    </div>
  </div>;
};